export default {
  state: {
    /**
     * 已获得礼包列表
     */
    ownedGifts: [],
    /**
     * 当前抽奖次数
     */
    lotteryCount: 0,
    /**
     * 已抽奖次数
     */
    drawnLotteryCount: 0,
    /**
     * 是否已分享
     */
    completeShare: false,
    /**
     * 收货地址
     */
    addressData: {},
    /**
     * 签到信息
     */
    signinInfo: {},
    /**
     * 队伍信息
     */
    teamInfo: null
  },
  mutations: {
    // 设置已获得礼包列表
    SET_OWNED_GIFTS(state, data) {
      state.ownedGifts = data
    },
    // 设置抽奖次数
    SET_LOTTERY_COUNT(state, data) {
      state.lotteryCount = +data
    },
    // 设置已抽奖次数
    SET_DRAWN_LOTTERY_COUNT(state, data) {
      state.drawnLotteryCount = +data
    },
    // 设置是否已分享
    SET_COMPLETE_SHARE(state, data) {
      state.completeShare = data
    },
    // 设置收货地址
    SET_ADDRESS_DATA(state, data) {
      state.addressData = data
    },
    // 设置签到信息
    SET_SIGNIN_INFO(state, data) {
      state.signinInfo = data
    },
    // 设置队伍信息
    SET_TEAM_INFO(state, data) {
      state.teamInfo = data
    }
  },
  actions: {
    // 更新活动相关数据
    updateAppData(context, data) {
      const { extra = {} } = data
      context.commit(
        'SET_OWNED_GIFTS',
        extra.take_award_item ? extra.take_award_item.map(el => +el) : []
      )
      context.commit('SET_LOTTERY_COUNT', extra.residue || 0)
      context.commit('SET_DRAWN_LOTTERY_COUNT', extra.draw_total || 0)
      context.commit('SET_COMPLETE_SHARE', extra.share_btn_status || false)
      context.commit(
        'SET_ADDRESS_DATA',
        extra.tel && extra.name && extra.address
          ? {
              tel: extra.tel || '',
              name: extra.name || '',
              address: extra.address || ''
            }
          : {}
      )
    },
    // 追加礼包数据
    setOwnedGifts(context, awardId) {
      context.commit('SET_OWNED_GIFTS', [...context.getters.ownedGifts, +awardId])
    },
    // 设置抽奖次数
    setLotteryCount(context, data) {
      context.commit('SET_LOTTERY_COUNT', data)
    },
    // 设置已抽奖次数
    setDrawnLotteryCount(context, data) {
      context.commit('SET_DRAWN_LOTTERY_COUNT', data)
    },
    // 设置是否已分享
    setCompleteShare(context, data) {
      context.commit('SET_COMPLETE_SHARE', data)
    },
    // 设置收货地址
    setAddressData(context, data) {
      context.commit('SET_ADDRESS_DATA', data)
    },
    // 设置签到信息
    setSigninInfo(context, data) {
      context.commit('SET_SIGNIN_INFO', data)
    },
    // 设置队伍信息
    setTeamInfo(context, data) {
      context.commit('SET_TEAM_INFO', {
        name: (data.leader_info && data.leader_info.team_name) || '',
        slogan:
          (data.leader_info && data.leader_info.slogan && data.leader_info.slogan.slice(0, 10)) ||
          '',
        members: data.all_team_info || [],
        inviteCode: (data.leader_info && data.leader_info.t_code) || ''
      })
    }
  },
  getters: {
    // 已获得礼包列表
    ownedGifts: state => state.ownedGifts,
    // 当前抽奖次数
    lotteryCount: state => state.lotteryCount,
    // 是否已完成抽奖
    completeLottery: state => state.drawnLotteryCount === 4,
    // 是否获取到所有的抽奖券
    hasAllLotteryCoupon: state => state.lotteryCount + state.drawnLotteryCount === 4,
    // 是否已分享
    completeShare: state => state.completeShare,
    // 收货地址
    addressData: state => state.addressData,
    // 签到项列表
    signinList: state =>
      (state.signinInfo.sign_day_data && Object.values(state.signinInfo.sign_day_data)) || [],
    // 已签到天数（包含已领取的天数）
    signinDays: (state, getters) => {
      return getters.signinList.filter(item => item.is_sign === 1 && item.is_award === 1).length
    },
    // 今天是否已签到并完成领奖
    isSigninToday: (state, getters) => {
      const todaySigninIndex =
        state.signinInfo.today_sign === 1
          ? state.signinInfo.cycle_sign_day
          : state.signinInfo.cycle_sign_day + 1
      const todaySigninItem = getters.signinList[todaySigninIndex - 1]
      return (
        (todaySigninItem && todaySigninItem.is_sign === 1 && todaySigninItem.is_award === 1) ||
        false
      )
    },
    // 完成所有签到
    isCompleteSignin: (state, getters) => getters.signinDays === 7,
    // 队伍名称
    teamName: state => state.teamInfo && state.teamInfo.name,
    // 队伍口号
    teamSlogan: state => state.teamInfo && state.teamInfo.slogan,
    // 队伍成员列表
    teamMemberList: state => state.teamInfo && state.teamInfo.members,
    // 组队邀请码
    teamInviteCode: state => state.teamInfo && state.teamInfo.inviteCode
  }
}
